import { render, staticRenderFns } from "./BlockEdit.vue?vue&type=template&id=6b75f642&"
import script from "./BlockEdit.vue?vue&type=script&lang=js&"
export * from "./BlockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b75f642')) {
      api.createRecord('6b75f642', component.options)
    } else {
      api.reload('6b75f642', component.options)
    }
    module.hot.accept("./BlockEdit.vue?vue&type=template&id=6b75f642&", function () {
      api.rerender('6b75f642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/BlockEdit.vue"
export default component.exports